// extracted by mini-css-extract-plugin
module.exports = {"cancelJobDialogActions":"_cancelJobDialogActions--24Vam","cancelJobDialogContent":"_cancelJobDialogContent--3Zbut"};